import { useMemo } from "react"
import { Dayjs } from "utils/dayjs"

import { Currency } from "config/constants"
import useExchangeRates from "./useExchangeRates"

interface IUseExchangeRateParams {
    currency: Currency | null
    date: Dayjs | null
}

export default function useExchangeRate({
    currency,
    date,
}: IUseExchangeRateParams) {
    const exchangeRatesParams = useMemo(() => {
        return {
            items: currency && date ? [
                {
                    currency,
                    date,
                },
            ] : []
        }
    }, [currency, date])
    const { getExchangeRate } = useExchangeRates(exchangeRatesParams)

    const exchangeRate = useMemo(() => {
        if (!currency || !date) return null
        return getExchangeRate({ currency, date })
    }, [currency, date, getExchangeRate])

    return exchangeRate
}
